import Roles from './Roles'
import {ReactElement} from "react";
import {RolesList} from "./rolesList";

interface ProtectedProps {
  access: keyof RolesList,
  children: ReactElement<any, any>,
}

export default function Protected({access, children}: ProtectedProps) {
  const hasAccess = Roles.hasAccess(access)

  return (
    hasAccess
      ? children || <div/>
      : <div/>
  )
}
